__turbopack_context__.v({
  "actions": "HomePage-module__wtOjGq__actions",
  "container": "HomePage-module__wtOjGq__container",
  "content": "HomePage-module__wtOjGq__content",
  "description": "HomePage-module__wtOjGq__description",
  "divider": "HomePage-module__wtOjGq__divider",
  "greeting": "HomePage-module__wtOjGq__greeting",
  "header": "HomePage-module__wtOjGq__header",
  "icon": "HomePage-module__wtOjGq__icon",
  "intro": "HomePage-module__wtOjGq__intro",
  "link": "HomePage-module__wtOjGq__link",
  "linkSeparator": "HomePage-module__wtOjGq__linkSeparator",
  "links": "HomePage-module__wtOjGq__links",
  "name": "HomePage-module__wtOjGq__name",
  "nameRow": "HomePage-module__wtOjGq__nameRow",
  "page": "HomePage-module__wtOjGq__page",
  "primaryAction": "HomePage-module__wtOjGq__primaryAction",
  "profileImage": "HomePage-module__wtOjGq__profileImage",
  "profileWrapper": "HomePage-module__wtOjGq__profileWrapper",
  "role": "HomePage-module__wtOjGq__role",
  "secondaryAction": "HomePage-module__wtOjGq__secondaryAction",
});
